import { render } from "./openOffers.vue?vue&type=template&id=008b9710"
import script from "./openOffers.vue?vue&type=script&lang=js"
export * from "./openOffers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__